import { create } from "zustand";

export interface GalleryState {
  post: null | any;
  postLoading: boolean;
  postError: null | string;
  posts: null | any[];
  postsLoading: boolean;
  postsError: null | string;
  setPost: (post: any) => void;
  setPostLoading: (postLoading: boolean) => void;
  setPostError: (postError: null | string) => void;
  setPosts: (posts: any) => void;
  setPostsLoading: (postsLoading: boolean) => void;
  setPostsError: (postsError: null | string) => void;
}

export const useGalleryStore = create<GalleryState>((set) => ({
  post: null,
  postLoading: false,
  postError: null,
  posts: [],
  postsLoading: false,
  postsError: null,
  setPost: (post) => set({ post }),
  setPostLoading: (postLoading) => set({ postLoading }),
  setPostError: (postError) => set({ postError }),
  setPosts: (posts) => set({ posts }),
  setPostsLoading: (postsLoading) => set({ postsLoading }),
  setPostsError: (postsError) => set({ postsError }),
}));
